// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Quote_wrapper__3mSwB"};